import { Icon } from '@alto-avios/alto-ui';
import { FC, useCallback, useContext } from 'react';

import { HEADER } from '../../consts';
import { pushGTMEvent } from '../../utilities';
import { Button } from '../Button';
import { AuthProps } from '../Header';
import { MobileMenuButton } from '../MobileMenuButton';
import { useOverlayContext } from '../Overlay/useOverlayContext';
import { CMSProviderContext } from '../services/content';

import styles from './MobileUserDetails.module.scss';

export type MobileUserDetailsProps = AuthProps & {
  isLoggedIn: boolean;
  showHelpCentre?: boolean;
};

export const MobileUserDetails: FC<MobileUserDetailsProps> = ({ isLoggedIn, loginProps, logoutProps, showHelpCentre }) => {
  const { header } = useContext(CMSProviderContext);
  const { account, helpCentre, registerLabel, registerUrl, signInLabel } = header.data;
  const overlayContext = useOverlayContext();

  const handleLoginPress = useCallback(() => {
    pushGTMEvent(HEADER, signInLabel);
    loginProps.onClick?.();
    overlayContext?.close();
  }, [overlayContext, loginProps, signInLabel]);

  const handleLogoutPress = useCallback(() => {
    pushGTMEvent(HEADER, account.logout.label);
    logoutProps.onClick?.();
    overlayContext?.close();
  }, [overlayContext, logoutProps, account.logout.label]);

  const handleHelpCentrePress = useCallback(() => {
    pushGTMEvent(HEADER, helpCentre.label);
    overlayContext?.close();
  }, [overlayContext, helpCentre.label]);

  const handleRegisterPress = useCallback(() => {
    pushGTMEvent(HEADER, registerLabel);
    overlayContext?.close();
  }, [overlayContext, registerLabel]);

  return (
    <ul className={styles.mobileUserDetails}>
      <li>
        {showHelpCentre && (
          <MobileMenuButton href={helpCentre.url} emphasis="neutral" onPress={handleHelpCentrePress} aria-label={helpCentre.label}>
            <Icon iconName="circle-question" iconPrefix="fal" /> {helpCentre.label}
          </MobileMenuButton>
        )}
      </li>

      {isLoggedIn ? (
        <li>
          <MobileMenuButton
            href={logoutProps.href}
            emphasis="accent"
            onPress={handleLogoutPress}
            hideChevron
            disableRouting
            aria-label={account.logout.label}
          >
            <Icon iconName={account.logout.icon} /> {account.logout.label}
          </MobileMenuButton>
        </li>
      ) : (
        <ul>
          <li>
            <Button href={loginProps.href} emphasis="secondary" onPress={handleLoginPress} disableRouting>
              {signInLabel}
            </Button>
          </li>
          <li>
            <Button href={registerUrl} onPress={handleRegisterPress} disableRouting>
              {registerLabel}
            </Button>
          </li>
        </ul>
      )}
    </ul>
  );
};
